module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/sakae_point3_1-254d1f98a9f470b954ef9b6cb402238b.jpg";